// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SelectInput_icon_3fTyG{position:absolute;right:22px;top:10px;pointer-events:none;opacity:0;transition:opacity .3s ease-in-out}.SelectInput_icon_3fTyG.SelectInput_visible_DRAi3{opacity:.5}.SelectInput_create_1H2tP{font-size:15px;position:relative;cursor:pointer;padding:16px 24px}.SelectInput_plus_ez6Cz{position:absolute;right:24px;top:18px}", ""]);
// Exports
exports.locals = {
	"icon": "SelectInput_icon_3fTyG",
	"visible": "SelectInput_visible_DRAi3",
	"create": "SelectInput_create_1H2tP",
	"plus": "SelectInput_plus_ez6Cz"
};
module.exports = exports;
